/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Edit': {
    width: 14,
    height: 12,
    viewBox: '0 0 14 12',
    data: '<path pid="0" d="M11.807 1.35L10.9.443a1.503 1.503 0 00-2.123 0l-2.01 2.01L.25 8.97V12h3.03l6.555-6.555 1.972-1.972a1.49 1.49 0 000-2.123zm-9.15 9.15H1.75v-.907l6.495-6.495.908.907L2.657 10.5zM6.25 12l3-3h4.5v3h-7.5z" _fill="#00204D"/>'
  }
})
